"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouter = require("react-router");

var _BasePagesSettingsContainer = _interopRequireDefault(require("./containers/BasePagesSettingsContainer"));

var _PageSettingsWrapper = _interopRequireDefault(require("./components/PageSettingsWrapper"));

var _AsyncPageTemplatesSettings = _interopRequireDefault(require("./containers/pageTemplates/AsyncPageTemplatesSettings"));

var _AsyncLogoAndFaviconContainer = _interopRequireDefault(require("./containers/branding/AsyncLogoAndFaviconContainer"));

var _AsyncPagesPersonalizationSettings = _interopRequireDefault(require("./containers/personalization/AsyncPagesPersonalizationSettings"));

var _AsyncTrackingIntegrationsContainer = _interopRequireDefault(require("./containers/integrations/AsyncTrackingIntegrationsContainer"));

var _AsyncPagesSEOSettings = _interopRequireDefault(require("./containers/seo/AsyncPagesSEOSettings"));

var _AsyncSystemPagesSettings = _interopRequireDefault(require("./containers/systemPages/AsyncSystemPagesSettings"));

var _UrlPathParams = require("settings-ui-sdk/constants/UrlPathParams");

var _tracking = require("settings-ui-app/utils/tracking");

var _default = _react.default.createElement(_reactRouter.Route, {
  path: _UrlPathParams.PAGES,
  component: _BasePagesSettingsContainer.default
}, _react.default.createElement(_reactRouter.IndexRedirect, {
  to: _UrlPathParams.ALL_DOMAINS
}), _react.default.createElement(_reactRouter.Route, {
  path: ":allDomainsOrDomainId",
  component: _PageSettingsWrapper.default
}, _react.default.createElement(_reactRouter.IndexRedirect, {
  to: _UrlPathParams.PAGE_TEMPLATES
}), _react.default.createElement(_reactRouter.Route, {
  path: _UrlPathParams.PAGE_TEMPLATES,
  component: _AsyncPageTemplatesSettings.default,
  onEnter: (0, _tracking.trackScreenUsingSideNav)(_UrlPathParams.PAGE_TEMPLATES)
}), _react.default.createElement(_reactRouter.Route, {
  path: _UrlPathParams.PAGE_BRANDING,
  component: _AsyncLogoAndFaviconContainer.default,
  onEnter: (0, _tracking.trackScreenUsingSideNav)(_UrlPathParams.PAGE_BRANDING)
}), _react.default.createElement(_reactRouter.Route, {
  path: _UrlPathParams.PAGE_PERSONALIZATION,
  component: _AsyncPagesPersonalizationSettings.default,
  onEnter: (0, _tracking.trackScreenUsingSideNav)(_UrlPathParams.PAGE_PERSONALIZATION)
}), _react.default.createElement(_reactRouter.Route, {
  path: _UrlPathParams.PAGE_INTEGRATIONS,
  component: _AsyncTrackingIntegrationsContainer.default,
  onEnter: (0, _tracking.trackScreenUsingSideNav)(_UrlPathParams.PAGE_INTEGRATIONS)
}), _react.default.createElement(_reactRouter.Route, {
  path: _UrlPathParams.PAGE_SEO,
  component: _AsyncPagesSEOSettings.default,
  onEnter: (0, _tracking.trackScreenUsingSideNav)(_UrlPathParams.PAGE_SEO)
}), _react.default.createElement(_reactRouter.Route, {
  path: _UrlPathParams.SYSTEM_PAGES,
  component: _AsyncSystemPagesSettings.default,
  onEnter: (0, _tracking.trackScreenUsingSideNav)(_UrlPathParams.SYSTEM_PAGES)
})));

exports.default = _default;
module.exports = exports.default;